import { render } from "./HeroiconsSolidFilter.vue?vue&type=template&id=59da8fe0"
const script = {}

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidFilter.vue"]])

export default __exports__